/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
import './side-menu.scss';

/* eslint-disable import/no-unresolved, import/default */

import sidemenuTemplate from './side-menu.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('tektelic.components.sideMenu', [])
    .directive('tkSideMenu', SideMenu)
    .name;

/*@ngInject*/
function SideMenu($compile, $templateCache, menu) {

    var linker = function (scope, element) {

        scope.sections = menu.getSections();

        var template = $templateCache.get(sidemenuTemplate);

        element.html(template);

        $compile(element.contents())(scope);
    }

    return {
        restrict: "E",
        link: linker,
        scope: {}
    };
}



// WEBPACK FOOTER //
// ./src/app/components/side-menu.directive.js